import React, { useState, useEffect, useMemo, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'
import {sdk} from './sdk.js';
import {sdkLocal} from './sdkLocal.js';
import { MarketItem } from "./MarketItem";

const MarketAdItem = ({ ad, item, zoneId = "peupleqc_wall", showPage = true, subid="" }) => {
  const [impressionTracked, setImpressionTracked] = useState(false);
  const [errors, setErrors] = useState({});
  const adContainerRef = useRef(null);

  const {id} = ad;
  
  if (!item) {
    return <div className="text-danger">L'annonce est introuvable.</div>;
  }

  const trackClick = async () => {
    try {
      console.log("Tracking click for ad:", ad);
      await sdk.models.AdsClick.addClick({
        adId: ad.id,
        marketItemId: item.id,
        zoneId: zoneId,
      });
    } catch (error) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        impression: "Erreur lors du suivi du clic.",
      }));
    }
  };

  const trackImpression = async () => {
    console.log("Track impression for market item", impressionTracked);
    try {
      console.log("impressionTracked", impressionTracked);
      if (!impressionTracked) {
        console.log("Start tracking",ad,item);
        const currentUrl = window.location.href;
        setImpressionTracked(true);
        console.log("ad:", ad);
        var imp_add = {
          adId: ad.id,
          marketItemId: item.id,
          zoneId: zoneId,
          refererUrl: currentUrl,
          subid: subid
        }
        console.log("imp to add:", imp_add);
        sdk.models.AdsImpression.addAdImpression(imp_add);
      }
    } catch (error) {
      console.log("got error:", error);
      setErrors((prevErrors) => ({
        ...prevErrors,
        impression: "Erreur lors du suivi de l'impression.",
      }));
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          trackImpression();
        }
      });
    }, {
      threshold: 0.5, // Quand 50% de la publicité est visible
    });

    if (adContainerRef.current) {
      observer.observe(adContainerRef.current);
    }

    return () => {
      if (adContainerRef.current) {
        observer.unobserve(adContainerRef.current);
      }
    };
  }, [item, impressionTracked]);

  return (
    <div ref={adContainerRef}>
      <MarketItem trackClick={trackClick} item={item} />
    </div>
  );
};

export { MarketAdItem };
